import {
	FETCH_MEDIA,
	FETCH_EVENT_MEDIA,
	CREATE_MEDIA,
	UPDATE_MEDIA,
	DELETE_MEDIA,
	CLEAR_MEDIA,
	CLEAR_EVENT_MEDIA,
	CREATE_LIBRARY,
	DELETE_LIBRARY,
} from '../actions/actionTypes';

const preState = {
	selectedMedia: {},
	libraries: [],
	media: [],
};

const eventMediaReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, libraries, media, selectedMedia, mediaID, library, libraryID } = action;

	switch (type) {
		case FETCH_MEDIA:
			return { ...stateDup, selectedMedia };
		case FETCH_EVENT_MEDIA:
			return { ...stateDup, media: [...media.nodes], libraries: [...libraries] };
		case CREATE_MEDIA:
			stateDup.media = [media, ...stateDup.media];
			return stateDup;
		case UPDATE_MEDIA:
			if (stateDup.selectedMedia.id === media.id)
				stateDup.selectedMedia = { ...stateDup.selectedMedia, ...media };
			stateDup.media = stateDup.media.map(m => (m.id === media.id ? { ...m, ...media } : m));
			return stateDup;
		case DELETE_MEDIA:
			stateDup.media = stateDup.media.filter(m => m.id !== mediaID);
			return stateDup;
		case CLEAR_MEDIA:
			return { ...stateDup, selectedMedia: {} };
		case CLEAR_EVENT_MEDIA:
			return { ...preState };
		case CREATE_LIBRARY:
			return { ...stateDup, libraries: [...state.libraries, library] };
		case DELETE_LIBRARY:
			return {
				...stateDup,
				libraries: state.libraries.filter(library => library.id !== libraryID),
			};
		default:
			return stateDup;
	}
};

export default eventMediaReducer;
